import { GuardedComponent } from '../components/guarded-component';
import { CreateCustomerPage } from '../features/customers/create-customer/create-customer.page';
import { EditCustomerPage } from '../features/customers/create-customer/edit-customer.page';
import { CreateOfficePage } from '../features/offices/create-office/create-office.page';
import { EditOfficePage } from '../features/offices/create-office/edit-office.page';
import { CustomerDetailsPage } from '../features/customers/customer-details/customer-details.page';
import { CustomersPage } from '../features/customers/customers.page';
import { UserPermissionName } from '../models/user-permission-name';

export const CustomersRoute = {
  path: '/customers',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_CUSTOMER]} showPermissionError>
          <CustomersPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'details/:id',
      name: 'Profile',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_CUSTOMER]} showPermissionError>
          <CustomerDetailsPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'create',
      name: 'New Customer',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_CUSTOMER]} showPermissionError>
          <CreateCustomerPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'edit/:id',
      name: 'Edit Customer',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.EDIT_CUSTOMER]} showPermissionError>
          <EditCustomerPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'details/:id/offices/create',
      name: 'New Office',
      element: (
        <GuardedComponent requiredPermissions={[]}>
          <CreateOfficePage />
        </GuardedComponent>
      ),
    },
    {
      path: 'details/:id/offices/edit/:officeID',
      name: 'Edit Office',
      element: (
        <GuardedComponent requiredPermissions={[]}>
          <EditOfficePage />
        </GuardedComponent>
      ),
    },
  ],
};
